<template>
    <div id="notifications" class="" >
      <div class="pgn push-on-sidebar-open pgn-circle" v-for="error in errors" style="display: table-caption;margin-top: -15px;">
        <div class="alert alert-danger row" role="alert" style="height:max-content;margin-bottom: 10px;" v-for="key in errorKeys(error)">
          <div class="pgn-message error-message-item">
            <div class="error-message-container">
              <ul style="margin-left: 35px;">
                <li v-for="(em, idx) in error[key]" :key="'error-message-' + idx ">{{em}}</li>
              </ul>
            </div>
            <div class="error-operation">
              <button type="button" class="close" data-dismiss="alert">
                <span aria-hidden="true">×</span>
                <span class="sr-only">Close</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        props: ["errors"],

        methods:{
          errorKeys(error) {
            if(error)
              return _.keys(error)
            return []
          },
        }
    }
</script>
<style scoped>
.closed {
  background: none;
  border: none;

}

.error-message-container {

}

.error-message-item {

}

.error-operations {

}

#notifications {
  position: fixed;
  top: 100px;
  z-index: 100;
  right: 100px;
}

</style>



// WEBPACK FOOTER //
// client/components/CRM/Notifications.vue